import type { Resource } from '../../';
export const country_countries_AT: Resource = {"default":"Austria"};
